import React, { useEffect, useState } from "react";
import {
    Col,
    Typography,
    Timeline,
    Steps,
    Button,
    Modal,
    notification,
    Empty,
    Spin,
    Row,
    Input,
    Image,
} from "antd";
import "dayjs/locale/th";

import "../../styles/grid/layout.less";
import { APIEndpointWeb, webapi } from "@client/web";
import { CheckCircleTwoTone, EditOutlined } from "@ant-design/icons";
import reject_case from "../../Image/reject_case.png";
import nocase from "../../Image/nocase.png";
import {
    CK_ACCESS_DATA_ROLE,
    CK_ACCESS_TOKEN,
    CK_SHARED_TOKEN
} from "@constant/constant";
import { useCookies } from "react-cookie";
import TextArea from "rc-textarea";

const { Step } = Steps;
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(timezone);
dayjs.extend(utc);

interface IDataStep {
    loading: boolean;
    datavalueStep: any;
    datadefaultSelectedKeys: any;
    idStep: number;
}

export interface IStep {
    date: string;
    status: string;
}
const HomeWebStatusStep: React.FC<IDataStep> = ({
    loading,
    datavalueStep,
    datadefaultSelectedKeys,
    idStep
}): JSX.Element => {
    const [comment, setComment] = useState<any>('');
    const [docid, setDocid] = useState<any>();
    const [postMedHistory, setPostMedHistory] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies([
        CK_SHARED_TOKEN,
        CK_ACCESS_TOKEN,
        CK_ACCESS_DATA_ROLE
    ]);
    const commentToHospital = (documentid: any) => {
        setIsModalOpen(true);
        setDocid(documentid)
    };

    const handleOk = async () => {
        const payload = {
            document_id: docid,
            comment: comment,
        };
        try {
            const { data } = await webapi.post(
                `${APIEndpointWeb.RequestIncomplete}`,
                payload,
                {
                    withCredentials: true,
                    // headers: { Authorization: `Bearer ${cookies.shared_token}` }
                }
            );
            // if (data.result) {
            //     window.location.reload();
            // }
            notification.success({
                message: "ส่งข้อความเรียบร้อยแล้ว"
            });
            // setLoading(false);
        } catch (error) {
            console.log(error);
        }
        setIsModalOpen(false);
        setComment('')
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const confirm = (documentid: any) => {
        Modal.confirm({
            title: "ยืนยันได้รับประวัติการรักษา",
            icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
            content: " ",
            okText: "ตกลง",
            onOk: async (): Promise<void> => {
                const databody = {
                    document_id: documentid,
                    status: "Approve"
                };
                try {
                    const { data } = await webapi.post(
                        `${APIEndpointWeb.GetInsuranceNotify}`,
                        databody,
                        {
                            withCredentials: true,
                            // headers: { Authorization: `Bearer ${cookies.shared_token}` }
                        }
                    );
                    if (data.result) {
                        window.location.reload();
                    }
                    setPostMedHistory(data);
                    notification.success({
                        message: "ได้รับประวัติการรักษาแล้ว"
                    });
                    // setLoading(false);
                } catch (error) {
                    console.log(error);
                }
                // setLoading(false);
            },
            cancelText: "ยกเลิก",
            okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
            cancelButtonProps: {
                style: { background: "#B5B5B5", color: "white", borderRadius: "5px" }
            }
        });
    };
    return (
        <>
            <Spin tip="กำลังโหลด..." spinning={loading}>
                {datavalueStep &&
                    Object.keys(datavalueStep.steps).length > 0 &&
                    datadefaultSelectedKeys.includes(idStep.toString()) ? (
                    datavalueStep.steps.map(
                        (step: any, index: number) => (
                            dayjs(step.step_2.date)
                                .locale("th")
                                .add(543, "year")
                                .format("DD/MM/YYYY"),
                            (
                                <>
                                    <div
                                        key={index}
                                        className="p-3 "
                                        style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "20px",
                                            height: "470px",
                                            boxShadow: " 0.25px 0.25px 3px rgba(0, 0, 0, 0.25)",
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {datavalueStep.status === "Rejected"
                                            ? (
                                                <Col className="image_reject">
                                                    <Image
                                                        alt="lodo"
                                                        src={reject_case}
                                                        preview={false}
                                                        style={{
                                                            width: "58%",
                                                        }}
                                                    />
                                                </Col>
                                            ) : datavalueStep.status === "Rejected From Hospital" ? (
                                                <Col className="image_reject">
                                                    <Image
                                                        alt="lodo"
                                                        src={nocase}
                                                        preview={false}
                                                        style={{
                                                            width: "58%",
                                                        }}
                                                    />
                                                </Col>
                                            ) : (
                                                <Timeline mode="left" className="dotline-timeline p-4 mt-5">
                                                    <Timeline.Item
                                                        className={
                                                            step.step_1.status === "Success"
                                                                ? "dot-bg"
                                                                : "dot-cdcdcd" && step.step_1.status === "Waiting"
                                                                    ? "dot-bg-yellow"
                                                                    : "dot-bg-yellow" && step.step_1.status === "Pending"
                                                                        ? "dot-bg-yellow"
                                                                        : "dot-cdcdcd"
                                                        }
                                                        color={
                                                            step.step_1.status === "Success"
                                                                ? "#147F8B"
                                                                : "gray" && step.step_1.status === "Waiting"
                                                                    ? "gray"
                                                                    : "gray" && step.step_1.status === "Pending"
                                                                        ? "#D6B400"
                                                                        : "gray"
                                                        }
                                                        style={{ marginBottom: 20 }}
                                                    >
                                                        <Step
                                                            style={{
                                                                color:
                                                                    step.step_1.status === "Success"
                                                                        ? "#147F8B"
                                                                        : "gray" && step.step_1.status === "Waiting"
                                                                            ? "gray"
                                                                            : "gray" && step.step_1.status === "Pending"
                                                                                ? "#D6B400"
                                                                                : "gray"
                                                            }}
                                                            title={
                                                                dayjs(step.step_1.date)
                                                                    .locale("th")
                                                                    .add(543, "year")
                                                                    .format("DD/MMMM/YYYY") === "01/มกราคม/544"
                                                                    ? ""
                                                                    : dayjs(step.step_1.date)
                                                                        .locale("th")
                                                                        .format("DD/MM/YYYY HH:mm น."
                                                                        )
                                                            }
                                                            subTitle={
                                                                step.step_1.status === "Success" ? (
                                                                    <Typography.Text
                                                                        className="font-weight-600 size-16"
                                                                        style={{ color: "#147F8B" }}
                                                                    >
                                                                        อยู่ในขั้นตอนผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                    </Typography.Text>
                                                                ) : "" || step.step_1.status === "Waiting" ? (
                                                                    <Typography.Text
                                                                        className="font-weight-600 size-16"
                                                                        style={{ color: "#D6B400" }}
                                                                    >
                                                                        อยู่ในขั้นตอนผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                    </Typography.Text>
                                                                ) : "" || step.step_1.status === "Pending" ? (
                                                                    <Typography.Text
                                                                        className="font-weight-600 size-16"
                                                                        style={{ color: "#D6B400" }}
                                                                    >
                                                                        อยู่ในขั้นตอนผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                    </Typography.Text>
                                                                ) : (
                                                                    ""
                                                                )
                                                            }
                                                            description={
                                                                step.step_1.status === "Success" ? (
                                                                    <Typography className="font-card-step">
                                                                        ผู้เอาประกันยินยอมให้เข้าถึงข้อมูลแล้ว
                                                                    </Typography>
                                                                ) : "" ||
                                                                    step.step_1.status === "Waiting" ||
                                                                    step.step_1.status === "Pending" ? (
                                                                    <Typography className="font-card-step">
                                                                        รอผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                    </Typography>
                                                                ) : (
                                                                    ""
                                                                )
                                                            }
                                                        />
                                                    </Timeline.Item>

                                                    {/* //step2 */}
                                                    <Timeline.Item
                                                        className={
                                                            step.step_2.status === "Success"
                                                                ? "dot-bg"
                                                                : "dot-cdcdcd" && step.step_2.status === "Waiting"
                                                                    ? "dot-cdcdcd"
                                                                    : "dot-cdcdcd" && step.step_2.status === "Pending"
                                                                        ? "dot-bg-yellow"
                                                                        : "dot-cdcdcd"
                                                        }
                                                        color={
                                                            step.step_2.status === "Success"
                                                                ? "#147F8B"
                                                                : "gray" && step.step_2.status === "Waiting"
                                                                    ? "gray"
                                                                    : "gray" && step.step_2.status === "Pending"
                                                                        ? "#D6B400"
                                                                        : "gray"
                                                        }
                                                        style={{ marginBottom: 20 }}
                                                    >
                                                        <Step
                                                            style={{
                                                                color:
                                                                    step.step_2.status === "Success"
                                                                        ? "#147F8B"
                                                                        : "gray" && step.step_2.status === "Waiting"
                                                                            ? "gray"
                                                                            : "gray" && step.step_2.status === "Pending"
                                                                                ? "#D6B400"
                                                                                : "gray"
                                                            }}
                                                            title={
                                                                dayjs(step.step_2.date)
                                                                    .locale("th")
                                                                    .add(543, "year")
                                                                    .format("DD/MMMM/YYYY") === "01/มกราคม/544"
                                                                    ? ""
                                                                    : dayjs(step.step_2.date)
                                                                        .locale("th")
                                                                        .format("DD/MM/YYYY HH:mm น.")
                                                            }

                                                            subTitle={
                                                                <Typography.Text
                                                                    className="font-weight-600 size-16"
                                                                    style={{
                                                                        color:
                                                                            step.step_2.status === "Success"
                                                                                ? "#147F8B"
                                                                                : "gray" && step.step_2.status === "Waiting"
                                                                                    ? "gray"
                                                                                    : "gray" && step.step_2.status === "Pending"
                                                                                        ? "#D6B400"
                                                                                        : "gray"
                                                                    }}
                                                                >
                                                                    อยู่ในขั้นตอนแพทย์ยืนยันข้อมูลประวัติการรักษา
                                                                </Typography.Text>
                                                            }
                                                            description={
                                                                step.step_2.status === "Success" ? (
                                                                    <Typography className="font-card-step">
                                                                        แพทย์ได้ทำการยืนยันประวัติการรักษาเรียบร้อย
                                                                    </Typography>
                                                                ) : "" ||
                                                                    step.step_2.status === "Waiting" ||
                                                                    step.step_2.status === "Pending" ? (
                                                                    <Typography className="font-card-step">
                                                                        รอแพทย์ยืนยันข้อมูลประวัติการรักษา
                                                                    </Typography>
                                                                ) : (
                                                                    ""
                                                                )
                                                            }
                                                        />
                                                    </Timeline.Item>

                                                    {/* //step3 */}
                                                    <Timeline.Item
                                                        className={
                                                            step.step_3.status === "Success"
                                                                ? "dot-bg"
                                                                : "dot-cdcdcd" && step.step_3.status === "Waiting"
                                                                    ? "dot-cdcdcd"
                                                                    : "dot-cdcdcd" && step.step_3.status === "Pending"
                                                                        ? "dot-bg-yellow"
                                                                        : "dot-cdcdcd"
                                                        }
                                                        color={
                                                            step.step_3.status === "Success"
                                                                ? "#147F8B"
                                                                : "gray" && step.step_3.status === "Waiting"
                                                                    ? "gray"
                                                                    : "gray" && step.step_3.status === "Pending"
                                                                        ? "#D6B400"
                                                                        : "gray"
                                                        }
                                                        style={{ marginBottom: 20 }}
                                                    >
                                                        <Step
                                                            style={{
                                                                color:
                                                                    step.step_3.status === "Success"
                                                                        ? "#147F8B"
                                                                        : "gray" && step.step_3.status === "Waiting"
                                                                            ? "gray"
                                                                            : "gray" && step.step_3.status === "Pending"
                                                                                ? "#D6B400"
                                                                                : "gray"
                                                            }}
                                                            title={
                                                                dayjs(step.step_3.date)
                                                                    .locale("th")
                                                                    .add(543, "year")
                                                                    .format("DD/MMMM/YYYY") === "01/มกราคม/544"
                                                                    ? ""
                                                                    : dayjs(step.step_3.date)
                                                                        .locale("th")
                                                                        .format("DD/MM/YYYY HH:mm น."
                                                                        )
                                                            }
                                                            subTitle={
                                                                <Typography.Text
                                                                    className="font-weight-600 size-16"
                                                                    style={{
                                                                        color:
                                                                            step.step_3.status === "Success"
                                                                                ? "#147F8B"
                                                                                : "gray" && step.step_3.status === "Waiting"
                                                                                    ? "gray"
                                                                                    : "gray" && step.step_3.status === "Pending"
                                                                                        ? "#D6B400"
                                                                                        : "gray"
                                                                    }}
                                                                >
                                                                    อยู่ในขั้นตอนบริษัทประกันยืนยันได้รับข้อมูลประวัติการรักษา
                                                                </Typography.Text>
                                                            }
                                                            description={
                                                                step.step_3.status === "Success" ? (
                                                                    <Typography className="font-card-step">
                                                                        บริษัทประกันได้รับการยืนยันข้อมูลประวัติการรักษา
                                                                    </Typography>
                                                                ) : "" ||
                                                                    step.step_3.status === "Waiting" ||
                                                                    step.step_3.status === "Pending" ? (
                                                                    <Typography className="font-card-step">
                                                                        บริษัทประกันยังไม่ยืนยันได้ข้อมูลประวัติการรักษา
                                                                    </Typography>
                                                                ) : (
                                                                    ""
                                                                )
                                                            }
                                                        />
                                                        <Row className="mt-2">
                                                            <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
                                                                <Button
                                                                    disabled={
                                                                        step.step_1.status !== "Success" ||
                                                                            step.step_2.status !== "Success" ||
                                                                            step.step_3.status !== "Pending"
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    style={{ borderRadius: 15 }}
                                                                    onClick={() => confirm(datavalueStep.document_id)}
                                                                    type="primary"
                                                                    block
                                                                >
                                                                    ยืนยันได้รับข้อมูล
                                                                </Button>
                                                            </Col>
                                                            <Col className="ml-3" xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
                                                                <Button
                                                                    disabled={
                                                                        step.step_1.status !== "Success" ||
                                                                            step.step_2.status !== "Success" ||
                                                                            step.step_3.status !== "Pending"
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    style={{ borderRadius: 15, }}
                                                                    onClick={() => commentToHospital(datavalueStep.document_id)}
                                                                    block
                                                                >
                                                                    แจ้งเอกสารไม่ครบ
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Timeline.Item>

                                                    {/* //step4 */}
                                                    <Timeline.Item
                                                        className={
                                                            postMedHistory === "OK"
                                                                ? "dot-bg"
                                                                : "dot-cdcdcd" && step.step_4.status === "Success"
                                                                    ? "dot-bg"
                                                                    : "dot-cdcdcd" && step.step_4.status === "Waiting"
                                                                        ? "dot-cdcdcd"
                                                                        : "dot-cdcdcd" && step.step_4.status === "Pending"
                                                                            ? "dot-bg"
                                                                            : "dot-cdcdcd"
                                                        }
                                                        color={
                                                            postMedHistory === "OK"
                                                                ? "#147F8B"
                                                                : "gray" && step.step_4.status === "Success"
                                                                    ? "#147F8B"
                                                                    : "gray"
                                                        }
                                                    //style={{ marginBottom: 20 }}
                                                    >
                                                        <Step
                                                            style={{
                                                                color:
                                                                    postMedHistory === "OK"
                                                                        ? "#147F8B"
                                                                        : "gray" && step.step_4.status === "Success"
                                                                            ? "#147F8B"
                                                                            : "gray" && step.step_4.status === "Pending"
                                                                                ? "#147F8B"
                                                                                : "gray"
                                                            }}
                                                            title={
                                                                dayjs(step.step_4.date)
                                                                    .locale("th")
                                                                    .add(543, "year")
                                                                    .format("DD/MMMM/YYYY") === "01/มกราคม/544"
                                                                    ? ""
                                                                    : dayjs(step.step_4.date)
                                                                        .locale("th")
                                                                        .format("DD/MM/YYYY HH:mm น."
                                                                        )
                                                            }
                                                            subTitle={
                                                                <Typography.Text
                                                                    className="font-weight-600 size-16"
                                                                    style={{
                                                                        color:
                                                                            postMedHistory === "OK"
                                                                                ? "#147F8B"
                                                                                : "gray" && step.step_4.status === "Success"
                                                                                    ? "#147F8B"
                                                                                    : "gray" && step.step_4.status === "Waiting"
                                                                                        ? "gray"
                                                                                        : "gray" && step.step_4.status === "Pending"
                                                                                            ? "#147F8B"
                                                                                            : "gray"
                                                                    }}
                                                                >
                                                                    การดำเนินการเสร็จสิ้น
                                                                </Typography.Text>
                                                            }
                                                            description={
                                                                step.step_4.status === "Success" ? (
                                                                    <Typography className="font-card-step">
                                                                        บริษัทประกันยืนยันได้รับประวัติการรักษาแล้ว
                                                                    </Typography>
                                                                ) : "" ||
                                                                    step.step_4.status === "Waiting" ||
                                                                    step.step_4.status === "Pending" ? (
                                                                    <Typography className="font-card-step">
                                                                        บริษัทประกันยืนยันได้รับประวัติการรักษาแล้ว
                                                                    </Typography>
                                                                ) : (
                                                                    ""
                                                                )
                                                            }
                                                        />
                                                    </Timeline.Item>
                                                </Timeline>
                                            )}
                                    </div >
                                </>
                            )
                        )
                    )
                ) : (
                    <div style={{ justifyItems: "center", marginTop: "29.6%" }}>
                        <Empty description={"ไม่มีข้อมูล"} />
                    </div>
                )}
            </Spin >
            <Modal title="แจ้งเอกสารไม่ครบ" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Input.TextArea placeholder='comment...' style={{ width: '100%', borderRadius: '8px' }} rows={3}
                    value={comment} onChange={(e) => { setComment(e.target.value) }}
                />
            </Modal>
        </>
    );
};

export default HomeWebStatusStep;
